import { getDarkenColor, getLightenColor } from ".";

export default (type, colors) => {
  const styles = {
    default: {
      'c-accorditabs__tab': {
        borderBottomColor: getLightenColor(colors.primary, 2.3)
      },
      'c-accorditabs__title': {
        customCSS: `
          .c-accorditabs--default-style .c-accorditabs__title {
            color: ${colors.secondary_dark};
          }
          .c-accorditabs--default-style .c-accorditabs__title:hover, 
          .c-accorditabs--default-style .c-accorditabs__title:active,  
          .c-accorditabs--default-style .c-accorditabs__title:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
          .c-accorditabs--default-style .c-accorditabs__tab.state-active .c-accorditabs__title {
            border-bottom-color: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-accorditabs--default-style .c-accorditabs__title {
            background: ${getDarkenColor(colors.light, 0.026)};
          }

        `
      }
    },
    type1: {
      'c-accorditabs__tab': {
        borderBottom: 'none',
        borderBottomColor: getLightenColor(colors.primary, 2.3)
      },
      'c-accorditabs__title': {
        customCSS: `
          .c-accorditabs--default-style .c-accorditabs__title {
            color: ${colors.secondary_dark};
          }
          .c-accorditabs--default-style .c-accorditabs__title:hover, 
          .c-accorditabs--default-style .c-accorditabs__title:active,  
          .c-accorditabs--default-style .c-accorditabs__title:focus {
            color: ${getDarkenColor(colors.secondary_dark, 0.2)};
          }
          .c-accorditabs--default-style .c-accorditabs__tab.state-active .c-accorditabs__title {
            border-bottom-color: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-accorditabs--default-style .c-accorditabs__title {
            background: ${getDarkenColor(colors.light, 0.026)};
          }

        `
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cAccorditabs.js